import React, { Fragment, useEffect, useRef, useState } from "react";
import moment from "moment";

import { useApolloClient } from "@apollo/client";

import { Accordion, AccordionTab } from "primereact/accordion";
import { SplitButton } from "primereact/splitbutton";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

/** contexts */
import { useSettings } from "../../context/settings";

/** services */

/** QUERIES MUTATIONS */
import UPDATE_DRIVER, { ADD_CATEGORY_DRIVER, REMOVE_CATEGORY_DRIVER, UPDATE_VEHICLE } from "../../provider/Drivers/mutation";
import { DRIVER, DRIVERS } from "./../../provider/Drivers/query";

/** utils */
import { maskCpfCnpj, getGraphsqErros, maskPhone, maskRealBeautify, toFloat } from "../../utilities/functions";
import { _driverStatus } from "../../utilities/constants";
import { classNames } from "primereact/utils";
import { useUser } from "../../context/users";
import { Dropdown } from "primereact/dropdown";
import CATEGORYS from "../../provider/Categorys/query";

const Crud = () => {
  const user = useUser();
  const userFranchise = user?.getUser()?.franchise;
  const actingRegion = user?.getUser()?.actingRegion;
  const settings = useSettings();
  const apollo = useApolloClient();
  const franchise_id = user?.getUser()?.franchise?.id;

  const [records, setRecords] = useState<any[]>([]);
  const [record, setRecord] = useState<iDriver>();

  const [franchise, setFranchise] = useState<any>(null);
  const [franchises, setFranchises] = useState<iFranchise[]>([]);
  const [region, setRegion] = useState<any>(null);
  const [regions, setRegions] = useState<iRegion[]>([]);
  const [categorys, setCategorys] = useState<iCategory[]>([]);
  const [category, setCategory] = useState<any>(null);
  const [load, setLoad] = useState(true);
  const [reload, setReload] = useState<boolean>(false);
  const [vehicleId, setVehicleId] = useState<any>();

  const [cpfFilter, setCpfFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [stateFilter, setStateFilter] = useState({ value: "AWAIT", label: "Aguardando aprovação", icon: "pi pi-clock" });

  const [loading, setLoading] = useState<boolean>(false);
  const [salving, setSalving] = useState<boolean>(false);
  const [approving, setApproving] = useState<boolean>(false);
  const [reproving, setReproving] = useState<boolean>(false);
  const [recordDialog, setRecordDialog] = useState<boolean>(false);
  const [balanceDialog, setBalanceDialog] = useState<boolean>(false);
  const [categoryDialog, setCategoryDialog] = useState<boolean>(false);

  const toast = useRef<any>(null);
  const dt = useRef<any>(null);

  const onInputChange = (e: any, name: string) => {
    let val = (e.target && e.target.value) || "";

    if (name === "new_balance") val = maskRealBeautify(val);

    let _record: any = { ...record };
    _record[name] = val;

    setRecord(_record);
  };

  const loadRecords = () => {
    setLoading(true);

    let filter: any = {};

    if (cpfFilter) filter.cpf = cpfFilter;
    if (nameFilter) filter.name = nameFilter;
    if (stateFilter?.value) filter.state = stateFilter.value;
    if (userFranchise?.id) filter.franchise_id = Number(userFranchise?.id);
    if (actingRegion?.id) filter.acting_region_id = Number(actingRegion.id);

    if (franchise?.code) filter.franchise_id = Number(franchise.code);

    if (region?.code) filter.acting_region_id = Number(region.code);

    let variables: any = {
      filter: { ...filter }
    };
    
    if (userFranchise?.id) variables.franchise_id = Number(userFranchise?.id);
    
    if (franchise?.code) variables.franchise_id = Number(franchise.code);

    apollo
      .query({
        query: DRIVERS,
        variables: {
          ...variables,
        },
        fetchPolicy: "no-cache",
      })
      .then(response => {
        const data = response.data.drivers;

        if (data) {
          setRecords(data);
        }

        setFranchises(response.data.franchises);
        setRegions(response.data.regions);
        setLoading(false);
        setLoad(false);
        setReload(false);
      })
      .catch(error => {
        // console.log('error: ', JSON.stringify(error));
        setRecords([]);
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
        setLoading(false);
        setLoad(false);
        setReload(false);
      });
  };

  const loadRecord = async (record_id: any) => {
    await apollo
      .query({
        query: DRIVER,
        variables: {
          id: parseInt(`${record_id}`),
        },
        fetchPolicy: "no-cache",
      })
      .then(response => {
        const data = response.data.driver;

        console.log('data', data); // Hong Li

        setRecord({ ...data });
        setRecordDialog(true);
      })
      .catch(error => {
        console.log('error', JSON.stringify(error))
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
      });
  };

  const loadCategorys = () => {
    if (!franchise_id) return;

    setLoading(true);

    const variables: any = {}

    if (franchise_id) variables.franchise_id = Number(franchise_id);

    apollo
      .query({
        query: CATEGORYS,
        variables,
        fetchPolicy: "no-cache",
      })
      .then(response => {
        const data = response.data.Categorys;

        setCategorys(data);
      })
      .catch(error => {
        setCategorys([]);
        console.log('CATEGORYS', JSON.stringify(error));
        settings?.setErrorMessage(getGraphsqErros(error));
        settings?.setVisibleError(true);
      });
  }

  const hideDialog = () => {
    setRecordDialog(false);
  };

  const approveDriver = () => {
    setApproving(true);

    apollo
      .mutate({
        mutation: UPDATE_DRIVER,
        variables: {
          data: {
            id: parseInt(`${record?.id}`),
            state: "APPROVED",
          },
        },
      })
      .then(async response => {
        await loadRecord(record?.id);
        loadRecords();

        toast.current.show({ severity: "success", summary: "Sucesso", detail: "Motorista Aprovado", life: 3000 });

        setApproving(false);
      })
      .catch(error => {
        console.log('approveDriver error: ', error);
        setApproving(false);
        settings.setErrorMessage(getGraphsqErros(error));
        settings.setVisibleError(true);
      });
  };

  const updateDriver = () => {
    const balance = parseFloat(toFloat(record?.new_balance)) * 100;
    setSalving(true);
    apollo
      .mutate({
        mutation: UPDATE_DRIVER,
        variables: {
          data: {
            id: parseInt(`${record?.id}`),
            balance: parseInt(`${balance}`),
          },
        },
      })
      .then(async response => {
        await loadRecord(record?.id);
        loadRecords();

        setSalving(false);
        toast.current.show({ severity: "success", summary: "Sucesso", detail: "Motorista atualizado", life: 3000 });

        hideBalanceDialog();
      })
      .catch(error => {
        console.log('UPDATE_DRIVER error:', JSON.stringify(error));
        setSalving(false);
        settings.setErrorMessage(getGraphsqErros(error));
        settings.setVisibleError(true);
      });
  };

  const vehicleState = (id: any, state: 'APPROVED' | 'DISAPPROVED') => {
    if (state === 'APPROVED') setApproving(true);
    if (state === 'DISAPPROVED') setReproving(true);

    const data = {
      id: parseInt(`${id}`),
      state,
    }

    apollo
      .mutate({
        mutation: UPDATE_VEHICLE,
        variables: {
          data,
        },
      })
      .then(async response => {
        await loadRecord(record?.id);
        loadRecords();

        toast.current.show({ severity: "success", summary: "Sucesso", detail: state === 'APPROVED' ? 'Veículo Aprovado' : "Veículo Reprovado", life: 3000 });
        setApproving(false);
        setReproving(false);
      })
      .catch(error => {
        setApproving(false);
        setReproving(false);
        settings.setErrorMessage(getGraphsqErros(error));
        settings.setVisibleError(true);
      });
  };

  const disapproveDriver = () => {
    setReproving(true);

    apollo
      .mutate({
        mutation: UPDATE_DRIVER,
        variables: {
          data: {
            id: parseInt(`${record?.id}`),
            state: "DISAPPROVED",
          },
        },
      })
      .then(async response => {
        await loadRecord(record?.id);
        loadRecords();

        toast.current.show({ severity: "success", summary: "Sucesso", detail: "Motorista Reprovado", life: 3000 });
        setReproving(false);
      })
      .catch(error => {
        setReproving(false);
        settings.setErrorMessage(getGraphsqErros(error));
        settings.setVisibleError(true);
      });
  };

  const addCategoryDriver = () => {
    if (!category || !vehicleId) return;

    setSalving(true);

    apollo
      .mutate({
        mutation: ADD_CATEGORY_DRIVER,
        variables: {
          data: {
            vehicle_id: parseInt(`${vehicleId}`),
            category_id: parseInt(`${category.code}`)
          },
        },
      })
      .then(async response => {
        await loadRecord(record?.id);
        loadRecords();

        setSalving(false);
        toast.current.show({ severity: "success", summary: "Sucesso", detail: "Motorista atualizado", life: 3000 });

        hideCategoryDialog();
      })
      .catch(error => {
        console.log('ADD_CATEGORY_DRIVER error:', JSON.stringify(error));
        setSalving(false);
        settings.setErrorMessage(getGraphsqErros(error));
        settings.setVisibleError(true);
      });
  };

  const removeCategoryDriver = (id: string | number, vehicle_id: string | number) => {
    setSalving(true);

    apollo
      .mutate({
        mutation: REMOVE_CATEGORY_DRIVER,
        variables: {
          data: {
            vehicle_id: parseInt(`${vehicle_id}`),
            category_id: parseInt(`${id}`)
          },
        },
      })
      .then(async response => {
        await loadRecord(record?.id);
        loadRecords();

        setSalving(false);
        toast.current.show({ severity: "success", summary: "Sucesso", detail: "Motorista atualizado", life: 3000 });

        hideCategoryDialog();
      })
      .catch(error => {
        console.log('REMOVE_CATEGORY_DRIVER error:', JSON.stringify(error));
        setSalving(false);
        settings.setErrorMessage(getGraphsqErros(error));
        settings.setVisibleError(true);
      });
  };

  const cpfBodyTemplate = (rowData: iDriver) => {
    return (
      <>
        <span className="p-column-title">CPF</span>
        {maskCpfCnpj(rowData?.cpf, "CPF")}
      </>
    );
  };

  const nameBodyTemplate = (rowData: iDriver) => {
    return (
      <>
        <span className="p-column-title">Nome</span>
        {rowData?.name ?? "-"}
      </>
    );
  };

  const statusBodyTemplate = (rowData: iDriver) => {
    return (
      <>
        <span className="p-column-title">Situação</span>
        <span className={`product-badge status-${rowData?.state}`}>{_driverStatus(rowData?.state)}</span>
      </>
    );
  };

  const balanceBodyTemplate = (rowData: iDriver) => {
    return (
      <>
        <span className="p-column-title">Saldo</span>
        <span className={`product-badge text-right status-balance-${rowData.balance <= 10000 ? "warning" : "success"}`}>
          R$ {maskRealBeautify(parseFloat(`${rowData?.balance}`) / 100, true)}
        </span>
      </>
    );
  };

  const onlineBodyTemplate = (rowData: iDriver) => {
    return (
      <>
        <span className="p-column-title">Online/Offline</span>
        <span className={`product-badge status-${rowData?.is_online ? "APPROVED" : "RETENTIVE"}`}>{rowData?.is_online ? "ONLINE" : "OFFLINE"}</span>
      </>
    );
  };

  const actionBodyTemplate = (rowData: iDriver) => {
    return (
      <div className="actions">
        <Button icon="pi pi-eye" className="p-button-rounded p-button-info mr-2" onClick={() => loadRecord(rowData.id)} />
      </div>
    );
  };

  const hideBalanceDialog = () => {
    setBalanceDialog(false);
  };

  const showBalanceDialog = () => {
    setBalanceDialog(true);
  };

  const hideCategoryDialog = () => {
    setCategoryDialog(false);

    setCategory(undefined);

    setVehicleId(undefined);
  };

  const leftToolbarTemplate = () => {
    return (
      <Fragment>
        <SplitButton
          label={stateFilter.label}
          icon={stateFilter.icon}
          model={[
            {
              label: "Aprovados",
              icon: "pi pi-check-circle",
              command(e) {
                setStateFilter({ value: "APPROVED", label: "Aprovados", icon: "pi pi-check-circle" });
              },
            },
            {
              label: "Aguardando aprovação",
              icon: "pi pi-clock",
              command(e) {
                setStateFilter({ value: "AWAIT", label: "Aguardando aprovação", icon: "pi pi-clock" });
              },
            },
            {
              label: "Reenvio",
              icon: "pi pi-history",
              command(e) {
                setStateFilter({ value: "RETENTIVE", label: "Reenvio", icon: "pi pi-history" });
              },
            },
            {
              label: "Reprovados",
              icon: "pi pi-ban",
              command(e) {
                setStateFilter({ value: "DISAPPROVED", label: "Reprovados", icon: "pi pi-ban" });
              },
            },
          ]}
          className="p-button-info mr-0 mb-0"></SplitButton>
      </Fragment>
    );
  };

  const balanceDialogFooter = (
    <>
      <Button label="Cancelar" disabled={salving} icon="pi pi-times" className="p-button-text" onClick={hideBalanceDialog} />
      <Button label={salving ? "Salvando..." : "Salvar"} disabled={salving} icon="pi pi-check" className="p-button-text" onClick={updateDriver} />
    </>
  );

  const categoryDialogFooter = (
    <>
      <Button label="Cancelar" disabled={salving} icon="pi pi-times" className="p-button-text" onClick={hideCategoryDialog} />
      <Button label={salving ? "Salvando..." : "Salvar"} disabled={salving} icon="pi pi-check" className="p-button-text" onClick={addCategoryDriver} />
    </>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">{loading ? "Carregando motoristas ..." : "Motoristas"}</h5>

      <form
        onSubmit={e => {
          e.preventDefault();
          loadRecords();
        }}>
        <div className="flex gap-2 sm:flex-row flex-column">
          {leftToolbarTemplate()}
          <span className="block mt-2 md:mt-0 p-input-icon-left">
            <i className="pi pi-search" />
            <InputText type="search" onInput={e => setCpfFilter(maskCpfCnpj(e.currentTarget.value, "CPF"))} placeholder="CPF" value={cpfFilter} />
          </span>
          <span className="block mt-2 md:mt-0 p-input-icon-left">
            <i className="pi pi-search" />
            <InputText type="search" onInput={e => setNameFilter(e.currentTarget.value)} placeholder="Nome" value={nameFilter} />
          </span>

          <Button
            icon={`pi ${loading ? "pi pi-spin pi-spinner" : "pi-search"}`}
            className="p-button-rounded p-button-success mr-2"
            onClick={() => loadRecords()}
          />
        </div>
      </form>
    </div>
  );

  const recordDialogFooter = (
    <>
      <Button label={"Atualizar saldo"} icon="pi pi-money-bill" className="p-button-info text-info-500" onClick={showBalanceDialog} />

      <Button
        label={reproving ? "Reprovando..." : "Reprovar"}
        icon="pi pi-thumbs-down"
        disabled={reproving || approving}
        className="p-button-danger text-red-500"
        onClick={disapproveDriver}
      />
      <Button
        label={approving ? "Aprovando..." : "Aprovar"}
        icon="pi pi-thumbs-up"
        disabled={reproving || approving}
        className="p-button-sucess text-red-500"
        onClick={approveDriver}
      />
    </>
  );

  useEffect(() => {
    loadRecords();
  }, [stateFilter.value, region?.code]);

  useEffect(() => {
    if (franchise?.code){
      setRegion(null);
      setReload(true);
      loadRecords();
    }
  }, [franchise?.code]);

  useEffect(() => {
    loadCategorys();
  }, [franchise_id])

  return (
    <div className="grid crud-demo">
      {userFranchise?.id && actingRegion?.id ? null : (
        load ? (
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
        ) : (
          <>
            <div className="card">
              <div className="flex flex-column md:flex-row flex-wrap">
                { !userFranchise?.id ? (
                  <div className="flex flex-column md:flex-row flex-wrap">
                    <label htmlFor="name">Franquia</label>
                    <div className="field col-12 md:col-12">
                      <Dropdown
                        value={franchise}
                        onChange={e => setFranchise(e.value)}
                        options={franchises.map(i => ({ code: i.id, name: i.name }))}
                        optionLabel="name"
                        placeholder="Selecione uma Franquia"
                      />
                    </div>
                  </div>
                ) : null }
  
  
                {/* { !actingRegion?.id ? (
                  <div className="flex flex-column md:flex-row flex-wrap">
                    <label htmlFor="name">Região</label>
                    <div className="field col-12 md:col-12">
                      {reload ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                      ) : (
                        <Dropdown
                          value={region}
                          onChange={e => setRegion(e.value)}
                          options={regions.map(i => ({ code: i.id, name: i.name }))}
                          optionLabel="name"
                          placeholder="Selecione uma Região"
                        />
                      )}
                    </div>
                  </div>
                ) : null } */}
              </div>
            </div>
          </>
        )
      )}
      <div className="col-12">
        <div className="card">
          <Toast ref={toast} />

          <DataTable
            ref={dt}
            value={records}
            dataKey="id"
            paginator
            stripedRows={true}
            rowHover
            showGridlines
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            className="datatable-responsive"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            emptyMessage="Nenhum registro encontrado"
            header={header}
            responsiveLayout="scroll">
            <Column field="cpf" header="CPF" sortable body={cpfBodyTemplate} headerStyle={{}}></Column>
            <Column field="name" header="Nome" sortable body={nameBodyTemplate} headerStyle={{}}></Column>
            <Column field="state" header="Situação Cadastral" body={statusBodyTemplate} sortable headerStyle={{}}></Column>

            <Column align="right" field="balance" header="Saldo" body={balanceBodyTemplate} sortable headerStyle={{}}></Column>
            <Column field="is_online" header="Online/Offline" body={onlineBodyTemplate} sortable headerStyle={{}}></Column>
            <Column header="Ações" className="flex flex-row align-items-center justify-content-end" body={actionBodyTemplate}></Column>
          </DataTable>

          {/* Modal informações */}
          <Dialog visible={recordDialog} style={{ width: "550px" }} modal={true} className="p-fluid" footer={recordDialogFooter} onHide={hideDialog}>
            <div className="flex flex-column md:flex-row flex-wrap ">
              <div className="field col-12 md:col-12">
                <h4 className="mb-2">{`${record?.id} - ${record?.name}`}</h4>
                <h5 className="mb-2 mt-2">{maskCpfCnpj(record?.cpf ?? "", "CPF")}</h5>

                <h6 className="mt-2">
                  <small>Telefone: {maskPhone(record?.phone)}</small>
                </h6>
                <h6 className="mt-2">
                  Saldo:
                  <span className={`ml-2 product-badge status-RETENTIVE`}>
                    {maskRealBeautify(parseFloat(`${record?.balance}`) / 100, true)}
                  </span>
                </h6>
                <h6 className="mt-2">
                  <span className={`product-badge ${record?.is_online ? "status-actived" : "status-disabled"}`}>
                    {record?.is_online ? "ONLINE" : "OFFILINE"}
                  </span>
                </h6>
              </div>
              <div className="field col-12 md:col-12">
                <Accordion activeIndex={0}>
                  <AccordionTab header="Dados da Pessoa" tabIndex={0}>
                    <div className="flex flex-column md:flex-row flex-wrap ">
                      <div className="field col-12 md:col-6">
                        <label htmlFor="situacaoCadastral">Situação</label>
                        <InputText id="situacaoCadastral" value={_driverStatus(record?.state ?? "")} readOnly className={"p-3"} />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label htmlFor="birth_date">Data de Nascimento</label>
                        <InputText
                          id="birth_date"
                          value={record?.birth_date ? moment(record?.birth_date).utc(false).format("DD/MM/YYYY") : "NÃO INFORMADO"}
                          readOnly
                          className={"p-3"}
                        />
                      </div>

                      <div className="field col-12 md:col-12">
                        <label htmlFor="email">E-mail</label>
                        <InputText id="dataSituacaoCadastral" value={record?.email ?? ""} readOnly className={"p-3"} />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label htmlFor="cnh_number">Nº CNH</label>
                        <InputText id="cnh_number" value={record?.cnh_number ?? ""} readOnly className={"p-3"} />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label htmlFor="cnh_expires">Vencimento CNH</label>
                        <InputText
                          id="cnh_expires"
                          value={record?.cnh_expires ? moment(record?.cnh_expires).utc(true).format("DD/MM/YYYY") : "NÃO INFORMADO"}
                          readOnly
                          className={"p-3"}
                        />
                      </div>
                    </div>
                  </AccordionTab>

                  <AccordionTab header="Documentos Pessoais" tabIndex={1}>
                    <div className="flex flex-column md:flex-row flex-wrap ">
                      {record?.image_path ? (
                        <div className="field col-12 md:col-6 text-center">
                          <label htmlFor="region">Foto de Perfil</label>
                          <a href={record.image_path} target={"_blank"} title="Foto de Perfil" rel="noreferrer">
                            <img
                              src={record?.image_path}
                              alt={"Foto de  Perfil"}
                              width="100"
                              height={100}
                              style={{ objectFit: "contain" }}
                              className="mt-0 mx-auto mb-5 block shadow-2"
                            />
                          </a>
                        </div>
                      ) : null}

                      {record?.cnh_image_path ? (
                        <div className="field col-12 md:col-6 text-center">
                          <label htmlFor="region">Foto CNH</label>
                          <a href={record.cnh_image_path} target={"_blank"} title="Foto da CNH" rel="noreferrer">
                            <img
                              src={record?.cnh_image_path}
                              alt={"Foto da CNH"}
                              width="100"
                              height={100}
                              style={{ objectFit: "contain" }}
                              className="mt-0 mx-auto mb-5 block shadow-2"
                            />
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </AccordionTab>
                  <AccordionTab header="Localização e Região" tabIndex={2}>
                    <div className="flex flex-column md:flex-row flex-wrap ">
                      <div className="field col-12 md:col-12">
                        <label htmlFor="region">Região de atuação</label>
                        <InputText id="region" value={record?.region?.name ?? ""} readOnly className={"p-3"} />
                      </div>

                      <div className="field col-12 md:col-12">
                        <label htmlFor="last_update">Última atualização</label>
                        <InputText
                          id="last_update"
                          value={
                            record?.last_update ? moment(record?.last_update).utc(true).format("DD/MM/YYYY HH:mm:ss") : "NENHUMA"
                          }
                          readOnly
                          className={"p-3"}
                        />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label htmlFor="latitude">Latitude</label>
                        <InputText id="latitude" value={record?.latitude} readOnly className={"p-3"} />
                      </div>

                      <div className="field col-12 md:col-6">
                        <label htmlFor="longitude">Longitude</label>
                        <InputText id="longitude" value={record?.longitude} readOnly className={"p-3"} />
                      </div>
                    </div>
                  </AccordionTab>

                  {record?.vehicles?.map((vehicle, index) => (
                    <AccordionTab
                      key={`vehicle-${index}`}
                      header={`Veículos: ${vehicle.model} (${vehicle.brand})`}
                      tabIndex={3 + record.vehicles.length + index}>
                      <div className="flex flex-column md:flex-row flex-wrap ">
                        <div className="field col-12 md:col-6">
                          <label htmlFor="brand">Marca</label>
                          <InputText id="brand" type={"text"} readOnly value={vehicle.brand} required className={"p-3"} />
                        </div>

                        <div className="field col-12 md:col-6">
                          <label htmlFor="brand">Modelo</label>
                          <InputText id="model" type={"text"} readOnly value={vehicle.model} required className={"p-3"} />
                        </div>
                      </div>

                      <div className="flex flex-column md:flex-row flex-wrap ">
                        <div className="field col-12 md:col-4">
                          <label htmlFor="year">Ano</label>
                          <InputText id="year" type={"text"} readOnly value={vehicle.year} required className={"p-3"} />
                        </div>

                        <div className="field col-12 md:col-4">
                          <label htmlFor="color">Cor</label>
                          <InputText id="color" type={"text"} readOnly value={vehicle.color} required className={"p-3"} />
                        </div>
                        <div className="field col-12 md:col-4">
                          <label htmlFor="board">Placa</label>
                          <InputText id="board" type={"text"} readOnly value={vehicle.board} required className={"p-3"} />
                        </div>
                      </div>

                      <div className="flex flex-column md:flex-row flex-wrap ">
                        {record?.image_path ? (
                          <div className="field col-12 md:col-6 text-center">
                            <label htmlFor="region">Foto do veículo</label>
                            <a href={vehicle.image_path} target={"_blank"} title="Foto do veículo" rel="noreferrer">
                              <img
                                src={vehicle.image_path}
                                alt={"Foto do veículo"}
                                width="70"
                                height={70}
                                style={{ objectFit: "contain" }}
                                className="mt-0 mx-auto mb-5 block shadow-2"
                              />
                            </a>
                          </div>
                        ) : null}

                        {record?.image_path ? (
                          <div className="field col-12 md:col-6 text-center">
                            <label htmlFor="region">CRLV do veículo</label>
                            <a href={vehicle.licensing_path} target={"_blank"} title="CRLV do veículo" rel="noreferrer">
                              <img
                                src={vehicle.licensing_path}
                                alt={"CRLV do veículo"}
                                width="70"
                                height={70}
                                style={{ objectFit: "contain" }}
                                className="mt-0 mx-auto mb-5 block shadow-2"
                              />
                            </a>
                          </div>
                        ) : null}

                        <div className="flex flex-column md:flex-row flex-wrap ">
                          <div className="field col-12 md:col-4">
                            <span className={`product-badge status-${vehicle.state}`}>{_driverStatus(vehicle.state)}</span>
                          </div>
                          <div className="field col-12 md:col-4">
                            <Button
                              label={reproving ? "Reprovando..." : "Reprovar"}
                              icon="pi pi-thumbs-down"
                              disabled={reproving || approving}
                              className="p-button-danger text-red-500"
                              onClick={() => vehicleState(vehicle.id, 'DISAPPROVED')}
                            />
                          </div>
                          <div className="field col-12 md:col-4">
                            <Button
                              label={approving ? "Aprovando..." : "Aprovar"}
                              icon="pi pi-thumbs-up"
                              disabled={reproving || approving}
                              className="p-button-sucess text-red-500"
                              onClick={() => vehicleState(vehicle.id, 'APPROVED')}
                            />
                          </div>
                        </div>

                        {franchise_id ? (
                          <Accordion activeIndex={0}>
                          <AccordionTab header="Categorias" tabIndex={2}>
                            {vehicle.categorys.map((category, index) => (
                              <div key={`category-${index}`} className="flex flex-column md:flex-row flex-wrap ">
                                <div className="field col-12 md:col-6">
                                  <label htmlFor="brand">{category.category.name}</label>
                                </div>

                                <div className="field col-12 md:col-6">
                                  <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-0" onClick={() => {
                                    removeCategoryDriver(category.category.id, vehicle.id)
                                  }} />
                                </div>
                              </div>
                            ))}

                            <div className="flex flex-column md:flex-row flex-wrap ">
                              <div className="field col-12 md:col-12">
                                <Button label="Adicionar Categoria" icon="pi pi-plus" className="p-button-success mr-2 " onClick={() => {
                                  setCategoryDialog(true);
                                  setVehicleId(vehicle.id);
                                }} />
                              </div>
                            </div>
                          </AccordionTab>
                          </Accordion>
                        ) : null}
                      </div>
                    </AccordionTab>
                  ))}

                  {record?.services?.map((service, index) => (
                    <AccordionTab key={`service-${index}`} header={`Serviço: ${service?.service?.name}`} tabIndex={3 + index}>
                      <div className="flex flex-column md:flex-row flex-wrap ">
                        <div className="field col-12 md:col-6">
                          <label htmlFor="base_rate">Tarifa base</label>
                          <InputText
                            id="base_rate"
                            type={"text"}
                            readOnly
                            value={maskRealBeautify(service.service.base_rate, true, "R$")}
                            required
                            className={"p-3 text-right"}
                          />
                        </div>

                        <div className="field col-12 md:col-6">
                          <label htmlFor="minimum_price">Preço mínimo</label>
                          <InputText
                            id="minimum_price"
                            type={"text"}
                            readOnly
                            value={maskRealBeautify(service.service.minimum_price, true, "R$")}
                            required
                            className={"p-3 text-right"}
                          />
                        </div>
                      </div>

                      <div className="flex flex-column md:flex-row flex-wrap ">
                        <div className="field col-12 md:col-4">
                          <label htmlFor="cost_per_minute">Custo por minuto</label>
                          <InputText
                            id="cost_per_minute"
                            type={"text"}
                            value={maskRealBeautify(service.service.cost_per_minute, true, "R$")}
                            readOnly
                            required
                            className={"p-3 text-right"}
                          />
                        </div>

                        <div className="field col-12 md:col-4">
                          <label htmlFor="cost_per_km">Custo por KM</label>
                          <InputText
                            id="cost_per_km"
                            type={"text"}
                            value={maskRealBeautify(service.service.cost_per_km, true, "R$")}
                            readOnly
                            className={"p-3 text-right"}
                          />
                        </div>

                        <div className="field col-12 md:col-4">
                          <label htmlFor="booking_fee">Custo adicionais</label>
                          <InputText
                            id="booking_fee"
                            type={"text"}
                            value={maskRealBeautify(service.service.booking_fee, true, "R$")}
                            readOnly
                            className={"p-3 text-right"}
                          />
                        </div>
                      </div>

                      <div className="flex flex-column md:flex-row flex-wrap ">
                        <div className="field col-12 md:col-12">
                          <div className="flex align-items-center justify-content-between mb-0 p-0 pb-0 mt-4">
                            <h5 className="m-0">Horários de pico </h5>
                          </div>

                          {service?.service.rush_hour?.data?.map((hour: iRushHour) => (
                            <>
                              <div className="flex align-items-center justify-content-between mb-0 p-0 pb-0 mt-4">
                                <label className="mb-3">
                                  {hour.start_hour} à {hour.end_hour}
                                </label>
                              </div>
                              <div className="flex flex-column md:flex-row flex-wrap ">
                                <div className="field col-12 md:col-4">
                                  <label htmlFor="start_hour">Horário de início</label>
                                  <InputText
                                    id="start_hour"
                                    type={"time"}
                                    readOnly
                                    value={hour.start_hour}
                                    className={"p-3"}
                                  />
                                </div>

                                <div className="field col-12 md:col-4">
                                  <label htmlFor="end_hour">Horário final</label>
                                  <InputText id="end_hour" type={"time"} readOnly value={hour.end_hour} className={"p-3"} />
                                </div>

                                <div className="field col-12 md:col-4">
                                  <label htmlFor="percent">Porcentagem</label>
                                  <InputText
                                    id="percent"
                                    type={"text"}
                                    value={maskRealBeautify(hour.percent, true, "%")}
                                    readOnly
                                    style={{ padding: "1.16rem" }}
                                  />
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </AccordionTab>
                  ))}
                </Accordion>
              </div>
            </div>
          </Dialog>

          {/* Modal saldos */}
          <Dialog
            visible={balanceDialog}
            // style={{ width: "450px" }}
            header="Atenção! Atualizar saldo"
            modal
            footer={balanceDialogFooter}
            onHide={hideBalanceDialog}>
            <div className="flex flex-column md:flex-row flex-wrap">
              <div className="field col-12 md:col-12">
                <label htmlFor="balance">* Novo Saldo</label>
                <InputText
                  id="balance"
                  style={{ width: "100%" }}
                  value={record?.new_balance}
                  onChange={e => onInputChange(e, "new_balance")}
                  required
                  autoFocus
                  type="string"
                  className={classNames("p-3", { "p-invalid": false })}
                />
              </div>
            </div>
          </Dialog>

          {/* Modal Adicionar Categoria */}
          <Dialog
            visible={categoryDialog}
            // style={{ width: "450px" }}
            header="Adicionar Categoria"
            modal
            footer={categoryDialogFooter}
            onHide={hideCategoryDialog}>
            <div className="flex flex-column md:flex-row flex-wrap">
              <div className="field col-12 md:col-12">
                <Dropdown
                  value={category}
                  onChange={e => setCategory(e.value)}
                  options={categorys.map(i => ({ code: i.id, name: i.name }))}
                  optionLabel="name"
                  placeholder="Selecione uma Categoria"
                />
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default Crud;
